"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '1.15.3',
};
//# sourceMappingURL=buildEnv.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@datadog/browser-rum/cjs/buildEnv.js
// module id = 754
// module chunks = 0